import moment from "moment";
const getDateInWords = (date) => {
  return moment(date).format("DD MMMM YYYY");
};
export default getDateInWords;
